import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  gap: 32px;
`;

export default ButtonGroup;
